"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segregateValues = exports.generateRangeTranslation = exports.getMaximumValue = exports.hasDiffValues = void 0;

var _messages = _interopRequireDefault(require("./messages"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var hasDiffValues = function hasDiffValues(v2Values, v1Values) {
  var unchangedValues = [];
  var removedValues = (0, _cloneDeep["default"])(v1Values);
  v2Values.forEach(function (v2Value) {
    var result = v2Value.range ? validateRange(v1Values, v2Value) : validateValue(v1Values, v2Value);

    if (!result) {
      return true;
    } else {
      unchangedValues.push(v2Value);
      removedValues.splice((0, _findIndex["default"])(removedValues, {
        value: v2Value.value
      }), 1);
    }
  });
  return unchangedValues.length !== v2Values.length || removedValues.length >= 1;
};

exports.hasDiffValues = hasDiffValues;

var getMaximumValue = function getMaximumValue(_ref) {
  var maximum = _ref.maximum,
      minimum = _ref.minimum,
      increment = _ref.increment;

  if ((0, _isNil["default"])(maximum)) {
    return undefined;
  } // eslint-disable-next-line no-mixed-operators


  return minimum + Math.floor((maximum - minimum) / increment) * increment;
};

exports.getMaximumValue = getMaximumValue;

var coerceToNumber = function coerceToNumber(numberString) {
  if (typeof numberString === 'number') {
    return numberString;
  }

  return numberString ? Number(numberString) : undefined;
};

function generateRangeExample(range) {
  var numericRange = {
    minimum: coerceToNumber(range.minimum),
    maximum: coerceToNumber(range.maximum),
    increment: coerceToNumber(range.increment)
  };
  var inc = numericRange.increment || 0.00000001;
  var max = getMaximumValue(numericRange);
  var exampleValues = [numericRange.minimum + inc, numericRange.minimum + 2 * inc].filter(function (v) {
    return v < (max || Infinity);
  });
  return numericRange.minimum === max ? max : "".concat(numericRange.minimum, ", ").concat(exampleValues.join(', '), " ... ").concat(max || '');
}

var generateRangeTranslation = function generateRangeTranslation(formatMessage, _ref2) {
  var minimum = _ref2.minimum,
      maximum = _ref2.maximum,
      increment = _ref2.increment;
  var includeExample = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ((0, _isNil["default"])(minimum)) {
    return '';
  }

  if (minimum === maximum) {
    return formatMessage(_messages["default"].exactly, {
      minimum: minimum
    });
  }

  return formatMessage(includeExample ? _messages["default"].rangeTranslationWithExample : _messages["default"].rangeTranslation, {
    minimum: minimum,
    maximum: maximum || formatMessage(_messages["default"].infinity),
    increment: increment ? formatMessage(_messages["default"].incrementAmount, {
      increment: increment
    }) : formatMessage(_messages["default"].noIncrement),
    rangeExample: generateRangeExample({
      minimum: minimum,
      maximum: maximum,
      increment: increment
    })
  });
};

exports.generateRangeTranslation = generateRangeTranslation;

var validateValue = function validateValue(v1Values, v2Option) {
  return v1Values.some(function (value) {
    return value.value === v2Option.value && value.type === v2Option.type;
  });
};

var validateRange = function validateRange(v1Values, v2Option) {
  return v1Values.some(function (value) {
    return value.range.minimum === v2Option.range.minimum && value.range.maximum === v2Option.range.maximum;
  });
};

var segregateValues = function segregateValues(unchanged, added, removed, v1Values, v2Values) {
  v2Values.forEach(function (v2Value) {
    var result = v2Value.range ? validateRange(v1Values, v2Value) : validateValue(v1Values, v2Value);

    if (!result) {
      added.push(v2Value);
    } else {
      unchanged.push(v2Value);
      removed.splice((0, _findIndex["default"])(removed, {
        value: v2Value.value
      }), 1);
    }
  });
  return {
    unchanged: unchanged,
    added: added,
    removed: removed
  };
};

exports.segregateValues = segregateValues;